import { useQueryClient } from '@tanstack/react-query'

interface DataGridRefetchProps {
    reactQueryKey: string
}

const useDataGridRefetch = ({ reactQueryKey }: DataGridRefetchProps) => {
    const queryClient = useQueryClient()

    const refetchCurrent = () => {
        const query = queryClient
            .getQueryCache()
            .getAll()
            .filter((q) => q.queryKey?.includes(reactQueryKey))

        const queryLast =
            query?.find((q) => q.isActive()) || query[query.length - 1]

        if (queryLast) {
            queryLast?.fetch()
        }
    }

    const refetchAll = () => {
        queryClient
            .getQueryCache()
            .getAll()
            .filter((q) => q.queryKey?.includes(reactQueryKey))
            ?.forEach((q) => q?.fetch())
    }

    return {
        refetchCurrent,
        refetchAll,
    }
}

export default useDataGridRefetch
